import axios from 'axios'
import { REACT_APP_PRECIOJUSTO_API } from '../../config'

export async function getConfigurations() {
    try {
        const response = await axios(
            `${REACT_APP_PRECIOJUSTO_API}/configurations?filter[where][key]=usdValue`
        )
        return response?.data
    } catch (error) {
        return error
    }
}
